import * as React from 'react';

const SvgMiscWalletFill = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "M20 4V2H2v17c0 1.65 1.35 3 3 3h17V6H5c-.54 0-1-.43-1-1V4h16Zm-4 7.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25-2.25-1.01-2.25-2.25 1.01-2.25 2.25-2.25Z" })
);

export { SvgMiscWalletFill as default };
//# sourceMappingURL=MiscWalletFill.es.js.map
